import { Injectable } from "@angular/core";
import { AppConfigService } from "../services/app-config.service";

@Injectable({
  providedIn: "root",
})

export class ApiFactoryEndPoints {
  readonly updateUserConsent: string;
  readonly getMobitrixAppUserConsentByDeviceId: string;
  readonly saveMobitrixAppUserConsent: string;
  readonly applyjob: string;
  readonly requestForPartner: string;
  readonly insertContactUsDetails: string;
  readonly insertWebUserInfo: string;
  readonly getVisitorCount: string;
  readonly getCount: string;
  readonly getMatrixDetails: string;
  readonly getOfferDetails: string;
  readonly getOfferAllowFor: string;
  readonly getBestProducts: string;
  readonly insertProductCart: string;
  readonly getProductCart: string;
  readonly getLocationByLocationCode: string;
  readonly getWebOrderMinimumDateTimeDetails: string;
  readonly getTimeSlotDetailsByUrlAndLocId: string;
  readonly getTimeSlotDetailsByUrl: string;
  readonly getMinimumOrderDetails: string;
  readonly getDeliverySetupDetails: string;
  readonly summaryOfferOperation: string;
  readonly checkServicesAllowedOrNotByDeliveryTime: string;
  readonly paymentLogVisit: string;
  readonly paymentLogPayClick: string;
  readonly getGatewayPaymentSetup: string;
  readonly sendGatewayPaymentRequest: string;
  readonly insertWebOrderTemp: string;
  readonly removeAllProductFromCart: string;
  readonly getSystemAndManualStockDetails: string;
  readonly getStateList: string;
  readonly getCityListByDistrictCode: string;
  readonly getDeliveryDetailsByCustomerCode: string;
  readonly insertDeliveryDetailsApp: string;
  readonly getDistrictListByStateCode: string;
  readonly getLocationByLocName: string;
  readonly validateCustomer: string;
  readonly insertGoogleCustomer: string;
  readonly getGoogleCustomer: string;
  readonly removeProductFromCart: string;
  readonly getLocationByCurrentUrl: string;
  readonly checkPincode: string;
  readonly signOutUser: string;
  readonly getWebOrderDetailsByLoggedInUser: string;
  readonly insertFeedBack: string;
  readonly getWebOrderPaymentHistory: string;
  readonly getWebOrderInvoiceDetails: string;
  readonly getAggregatorSetupByUrl: string;
  readonly getExceptionWebOrderByOrderNo: string;
  readonly emptyProductCart: string;
  readonly decryptAnyData: string;
  readonly ccAvenuePayment: string;

  constructor(
    private appConfig: AppConfigService
  ) {
    // this.insertWebUserInfo = this.appConfig.setting.communicationServerUrl + "capital-food-user-info/insert";
    this.getVisitorCount = this.appConfig.setting.apiUrl + "get-visitor-count";
    this.getCount = this.appConfig.setting.apiUrl + "get-count";
    this.getMatrixDetails = this.appConfig.setting.apiUrl + "admin/master/view/productmatrix/getmatrixbyurl";
    this.getOfferDetails = this.appConfig.setting.cartApiUrl + "get-offer-details";
    this.getOfferAllowFor = this.appConfig.setting.apiUrl + "admin/transaction-setup/offer-setup/get-offer-allow-for";
    this.getBestProducts = this.appConfig.setting.apiUrl + "admin/transaction-setup/get-web-order-best-products-by-companyid";
    this.insertProductCart = this.appConfig.setting.cartApiUrl + "productcart/insert";
    this.getProductCart = this.appConfig.setting.cartApiUrl + "productcart/get-cart-product"
    this.getLocationByLocationCode = this.appConfig.setting.apiUrl + "admin/master/view/location/getLocationByLocId";
    this.getWebOrderMinimumDateTimeDetails = this.appConfig.setting.apiUrl + "admin/transaction-setup/web-order-min-date-time-setup/get-min-date-time-details-by-companyid";
    this.getTimeSlotDetailsByUrl = this.appConfig.setting.apiUrl + "admin/transaction-setup/web-order-delivery-time-slot-setup/get-time-slot-by-company-code";
    this.getSystemAndManualStockDetails = this.appConfig.setting.apiUrl + "admin/transaction-setup/billing-setup/get-stock-details-by-loc-and-url";
    // this.getDeliveryDetailsByCustomerCode = this.appConfig.setting.oldApiUrl + "admin/master/customerdeliverydetails/get-by-customer-code-and-pin-web";
    this.getDeliveryDetailsByCustomerCode = this.appConfig.setting.oldApiUrl + "admin/master/view/customerdeliverydetails/getbycustomercodeforb2c";
    this.getLocationByLocName = this.appConfig.setting.apiUrl + "admin/master/view/location/getLocationByLocName";
    this.validateCustomer = this.appConfig.setting.cartApiUrl + "customer/validate-customer";
    this.insertGoogleCustomer = this.appConfig.setting.cartApiUrl + "customer/insert-google";
    this.getGoogleCustomer = this.appConfig.setting.cartApiUrl + "customer/get-google";
    this.getDistrictListByStateCode = this.appConfig.setting.apiUrl + "admin/master/view/location/get-by-state-code";
    this.getCityListByDistrictCode = this.appConfig.setting.apiUrl + "admin/master/view/location/get-by-district-code";
    this.getStateList = this.appConfig.setting.apiUrl + "admin/master/view/state/getstates";
    this.insertDeliveryDetailsApp = this.appConfig.setting.oldApiUrl + "admin/master/customerdeliverydetails/insert-web";
    this.getMinimumOrderDetails = this.appConfig.setting.apiUrl + "admin/transaction-setup/web-order-min-value-setup/get-min-value-details-by-companyid";
    this.getDeliverySetupDetails = this.appConfig.setting.apiUrl + "admin/transaction-setup/delivery-setup/get-delivery-details-by-url";
    this.checkServicesAllowedOrNotByDeliveryTime = this.appConfig.setting.apiUrl + "order/web-orders/check-services-allowed-or-not-by-delivery-time";
    this.paymentLogPayClick = this.appConfig.setting.cartApiUrl + "payment-log/pay-click";
    this.paymentLogVisit = this.appConfig.setting.cartApiUrl + "payment-log/visit";
    this.getGatewayPaymentSetup = this.appConfig.setting.oldApiUrl + "common/admin/transaction-setup/gatewayPaymentSetupByCompanyAndProviderAndUrl"
    this.sendGatewayPaymentRequest = this.appConfig.setting.integrationUrl + "api/v1/encryptAnyData";
    this.insertWebOrderTemp = this.appConfig.setting.cartApiUrl + "insert-weborder-temp";
    this.removeProductFromCart = this.appConfig.setting.cartApiUrl + "productcart/remove-product";
    this.getLocationByCurrentUrl = this.appConfig.setting.apiUrl + "admin/transaction-setup/location-setup/get-web-order-locations-by-url";
    this.insertWebUserInfo = this.appConfig.setting.apiUrl + "web-user-info/insert";
    this.checkPincode = this.appConfig.setting.apiUrl + "admin/transaction-setup/location-setup/check-correct-pincode";
    this.signOutUser = this.appConfig.setting.loginLogoutUrl + "googleSignOut";
    this.removeAllProductFromCart = this.appConfig.setting.cartApiUrl + "productcart/remove-all-product";
    this.getWebOrderDetailsByLoggedInUser = this.appConfig.setting.apiUrl + "order/web-orders/get-web-order-details-by-logged-user";
    this.insertFeedBack = this.appConfig.setting.oldApiUrl + "common/saveFeedBack";
    this.getWebOrderPaymentHistory = this.appConfig.setting.apiUrl + "order/web-orders/get-payment-history";
    this.getWebOrderInvoiceDetails = this.appConfig.setting.cartApiUrl + "get-web-order-invoice-details";
    this.getTimeSlotDetailsByUrlAndLocId = this.appConfig.setting.apiUrl + "admin/transaction-setup/get-time-slot-by-url-and-locid";
    this.summaryOfferOperation = this.appConfig.setting.oldApiUrl + "sales/pos/cash-register/summaryOfferOperationWebOrder";
    this.getAggregatorSetupByUrl = this.appConfig.setting.apiUrl + "admin/transaction-setup/platform-setup/get-restaurant-aggregator-details-by-url-latitude-longitude";
    this.getExceptionWebOrderByOrderNo = this.appConfig.setting.apiUrl + "order/web-order/get-exception-weborder-by-order-no";
    this.emptyProductCart = this.appConfig.setting.cartApiUrl + "productcart/remove-all-cart-product";
    this.decryptAnyData = this.appConfig.setting.integrationUrl + "api/v1/decryptAnyData";
    this.ccAvenuePayment = this.appConfig.setting.integrationUrl + "api/v1/encryptData";

  }
}